module.exports = __webpack_public_path__ + "static/media/182-niue.daa4b4ab.svg";